import * as Yup from "yup";

export type VersOre = {
        id? :number;
        ditta? :number;
        datareg? : Date | null;
        variante?: string;
        opzione? :string;
        coddip? :string;
        oreord? : number;
        minord?: number;
        codprog?: string;
        note?: string;
        codatt?: string;
        codnodo?: string;
        datains?: Date | null;
        km?: number;
        trasf?: number;
        indlavoraz?:  number,
        indora?: number,
        indtipovers?: number,
        valutadqr?: string,
        umtempodqr?: number,
        indtipocosdqr?: number,
        costodqr?: number,
        impdqr?: number,
        protocollo?: number,
        idprog?: string,
        idnodo?: string,
        idatt?: string,
        luogo?: string,
        qtalav?: number,
        inizlav?: Date | null,
        finelav?: Date | null,
        orestraord? : number;
        minstraord?: number;
  };

export type  VersOreApiResponse = {
  results: Array<VersOre>;
  count: number;
};
export function mapJsonToVersOreApiResponse(jsonData: any): VersOreApiResponse {
   // console.log("JSON:",jsonData);
  const mappedData: VersOreApiResponse = {
    count: jsonData.count,
    results: jsonData.results.map((item: any) => ({
        id : item.PD44_PRGMVORE_PD31,
        ditta :item.PD44_DITTA_CG18,
        datareg : item.PD44_DATAREG ? new Date(item.PD44_DATAREG) : null,
        variante :item.PD44_VARIANTE,
        opzione:  item.PD44_OPZIONE,
        coddip :item.PD44_CODDIP_PD06,
        oreord :item.PD44_OREORD,
        minord :item.PD44_MINORD,
        codprog :item.PD44_CODPROG_PD14,
        note :item.PD44_NOTE,
        codatt: item.PD44_CODATTIVITA_PD0D,
        codnodo: item.PD44_CODNODO_PD0C,
        datains:  item.PD44_DATAINS ? new Date(item.PD44_DATAINS) : null,
        indlavoraz:  item.PD44_INDLAVORAZ,
        indora: item.PD44_INDORA,
        indtipovers: item.PD44_INDTIPOVERS,
        valutadqr:  	item.PD44_VALUTADQR,
        umtempodqr:     item.PD44_UMTEMPODQR,
        indtipocosdqr:  item.PD44_INDTIPOCOSDQR,
        costodqr:       item.PD44_COSTODQR,
        impdqr:         item.PD44_IMPDQR,
        protocollo:     item.PD44_PROTOCOLLO,
        luogo:          item.PD44_NUMRAP,
        qtalav:         item.PD44_QTALAV,
        inizlav:        item.PD44_INIZLAV,
        finelav:        item.PD44_FINELAV,
        orestraord :    item.PD44_ORESTRAORD,
        minstraord :    item.PD44_MINSTRAORD,

    }))
  };

    // console.log("Mapped:",mappedData);
  return mappedData;
};
export function mapJsonToVersOre(jsonData: any): VersOre {
    // Log the incoming jsonData for debugging
    //console.log("Incoming JSON data:", jsonData);

    return {
        id: jsonData.PD44_PRGMVORE_PD31 || '',
        ditta: jsonData.PD44_DITTA_CG18 || '',
        datareg: jsonData.PD44_DATAREG ? new Date(jsonData.PD44_DATAREG) : null,
        variante: jsonData.PD44_VARIANTE || '',
        opzione: jsonData.PD44_OPZIONE || '',
        coddip: jsonData.PD44_CODDIP_PD06 || '',
        oreord: jsonData.PD44_OREORD || 0,
        minord: jsonData.PD44_MINORD || 0,
        codprog: jsonData.PD44_CODPROG_PD14 || '',
        note: jsonData.PD44_NOTE || '',
        codatt: jsonData.PD44_CODATTIVITA_PD0D || '',
        codnodo: jsonData.PD44_CODNODO_PD0C || '',
        datains: jsonData.PD44_DATAINS ? new Date(jsonData.PD44_DATAINS) : null,
        indlavoraz: jsonData.PD44_INDLAVORAZ || '',
        indora: jsonData.PD44_INDORA || '',
        indtipovers: jsonData.PD44_INDTIPOVERS || '',
        valutadqr: jsonData.PD44_VALUTADQR || 0,
        umtempodqr: jsonData.PD44_UMTEMPODQR || '',
        indtipocosdqr: jsonData.PD44_INDTIPOCOSDQR || '',
        costodqr: jsonData.PD44_COSTODQR || 0,
        impdqr: jsonData.PD44_IMPDQR || 0,
        protocollo: jsonData.PD44_PROTOCOLLO || '',
        luogo: jsonData.PD44_NUMRAP || '',
        qtalav: jsonData.PD44_QTALAV || 0,
        inizlav: jsonData.PD44_INIZLAV || '',
        finelav: jsonData.PD44_FINELAV || '',
        orestraord: jsonData.PD44_ORESTRAORD || 0,
        minstraord: jsonData.PD44_MINSTRAORD || 0,
        // idprog: jsonData.PD44_CODPROG_PD14.trim() || '',
        // idnodo: `${jsonData.PD44_DITTA_CG18.trim()}-${jsonData.PD44_CODPROG_PD14.trim()}-${jsonData.PD44_CODNODO_PD0C.trim()}` || '',
        // idatt: `${jsonData.PD44_DITTA_CG18.trim()}-${jsonData.PD44_CODPROG_PD14.trim()}-${jsonData.PD44_CODATTIVITA_PD0D.trim()}` || '',
    };
}
export function mapVersOreToJson(versOre: VersOre) {
      return {
        PD44_PRGMVORE_PD31:        versOre.id 		,
        PD44_DITTA_CG18:           versOre.ditta 	,
        PD44_DATAREG:              versOre.datareg 	,
        PD44_VARIANTE:             versOre.variante ,
        PD44_OPZIONE:              versOre.opzione 	,
        PD44_CODDIP_PD06:          versOre.coddip 	,
        PD44_OREORD:               versOre.oreord 	,
        PD44_MINORD:               versOre.minord 	,
        PD44_CODPROG_PD14:         versOre.codprog 	,
        PD44_NOTE:                 versOre.note 	,
        PD44_CODATTIVITA_PD0D:     versOre.codatt	,
        PD44_CODNODO_PD0C:         versOre.codnodo	,
        PD44_DATAINS:              versOre.datains	,
        PD44_INDLAVORAZ:           versOre.indlavoraz	,
        PD44_INDORA:               versOre.indora	,
        PD44_INDTIPOVERS:          versOre.indtipovers	,
        PD44_VALUTADQR:            versOre.valutadqr,
        PD44_UMTEMPODQR:        versOre.umtempodqr,
        PD44_INDTIPOCOSDQR:     versOre.indtipocosdqr,
        PD44_COSTODQR:          versOre.costodqr,
        PD44_IMPDQR:            versOre.impdqr,
        PD44_PROTOCOLLO:        versOre.protocollo,
        PD44_NUMRAP:            versOre.luogo,
        PD44_QTALAV:            versOre.qtalav,
        PD44_INIZLAV:           versOre.inizlav,
        PD44_FINELAV:           versOre.finelav,
        PD44_ORESTRAORD:               versOre.orestraord 	,
        PD44_MINSTRAORD:               versOre.minstraord 	,


       };
 }



export  type ProgettiDTO = {
    codprog: string;
    label: string;
    };

export type  ProgettiDTOApiResponse = {
  results: Array<ProgettiDTO>;
  count: number;
};
export function mapJsonToProgettiDTOApiResponse(jsonData: any): ProgettiDTOApiResponse {
  const mappedData: ProgettiDTOApiResponse = {
    count: jsonData.count,
    results: jsonData.results.map((item: any) => ({
      codprog: item.VBT01_CODPROG,
      label: item.VBT01_DESPROG,
    }))
  };

  return mappedData;
};

export  type NodiDTO = {
    codnodo: string;
    label: string;
    };

export type  NodiDTOApiResponse = {
  results: Array<NodiDTO>;
  count: number;
};
export function mapJsonToNodiDTOApiResponse(jsonData: any): NodiDTOApiResponse {
  const mappedData: NodiDTOApiResponse = {
    count: jsonData.count,
    results: jsonData.results.map((item: any) => ({
      codprog: item.VBT04_CODNODO,
      label: item.VBT04_DESNODO,
    }))
  };

  return mappedData;
};

export  type AttivitaDTO = {
    codatt: string;
    label: string;
    };

export type  AttivitaDTOApiResponse = {
  results: Array<AttivitaDTO>;
  count: number;
};
export function mapJsonToAttivitaDTOApiResponse(jsonData: any): AttivitaDTOApiResponse {
  const mappedData: AttivitaDTOApiResponse = {
    count: jsonData.count,
    results: jsonData.results.map((item: any) => ({
      codatt: item.VBT05_CODATT,
      label: item.VBT05_DESATT,
    }))
  };

  return mappedData;
};


export type MinordItem = { id: number; label: string };

export const MinordList: MinordItem[] = [
  { id: 0, label: "0" },
  { id: 15, label: "15" },
  { id: 30, label: "30" },
  { id: 45, label: "45" },
];

export type OpzioniItem = { id: string; label: string };

export const OpzioniList: OpzioniItem[] = [
  { id: "FATTMAN",  label: "FATTMAN" },
  { id: "FATT",  label: "FATT" },
  { id: "NOFATT", label: "NOFATT" },
  { id: "PREP", label: "PREP" },
  { id: "PREPRI", label: "PREPRI" },
  { id: "PREPUT", label: "PREPUT" },
  { id: "SOSP", label: "SOSP" },
];

export type LuoghiItem = { id: string; label: string };

export const LuoghiList: LuoghiItem[] = [
  { id: "SEDE",  label: "SEDE" },
  { id: "SMART", label: "SMART WORK" },
  { id: "TRASFERTA", label: "TRASFERTA" },
];








// ATTENZIONE NON CANC KEYCLOAK

export type Dipendenti = {
        id? :number;
        codditta? :string;
        coddip? :string;
        username? :string;
        tipodip?: string;
        nomedip?: string;
        flgdel?: string;
        label?: string;
        flgprog?: string;
  };

export type  DipendentiApiResponse = {
  results: Array<Dipendenti>;
  count: number;
};

export function mapJsonToDipendentiApiResponse(jsonData: any): DipendentiApiResponse {
  const mappedData: DipendentiApiResponse = {
            count: jsonData.count,
            results: jsonData.results.map((item: any) => ({
            id:           item.VBT03_ID,
            codditta:  item.VBT03_CODDITTA,
            coddip:  item.VBT03_CODDIP,
            username:   item.VBT03_USERNAME,
            tipodip:   item.VBT03_TIPODIP,
            nomedip:   item.VBT03_NOMEDIP,
            flgdel:   item.VBT03_FLGDEL,
            label:   item.VBT03_NOMEDIP,
            flgprog:   item.VBT03_FLGPROG,
    }))
  };

  return mappedData;
};

// export type Gruppi = {
//         id? :number;
//         username? :string;
//         gruppo? :string;
//
//   };
//
// export type  GruppiApiResponse = {
//   results: Array<Gruppi>;
//   count: number;
// };
//
// export function mapJsonToGruppiApiResponse(jsonData: any): GruppiApiResponse {
//   const mappedData: GruppiApiResponse = {
//             count: jsonData.count,
//             results: jsonData.results.map((item: any) => ({
//             id:           item.VPV35_ID,
//             username:   item.VPV35_USERNAME,
//             gruppo:   item.VPV35_GRUPPO
//
//     }))
//   };
//
//   return mappedData;
// };

export type Progetti = {
        idprog? :string;
        codprog? :string;
        ditta? :number;
        desprog? :string;
        indclibloc? :number;
        desprogblocco?: string;
        label?: string;
        gruppo?: string;
        ref?: string;
        statoprog?: string;
        molt?: number;
  };

export type  ProgettiApiResponse = {
  results: Array<Progetti>;
  count: number;
};
export function mapJsonToProgettiApiResponse(jsonData: any): ProgettiApiResponse {
  const mappedData: ProgettiApiResponse = {
            count: jsonData.count,
            results: jsonData.results.map((item: any) => ({
            idprog:    item.VBT01_ID,
            codprog:  item.VBT01_CODPROG,
            ditta:    item.VBT01_DITTA,
            desprog:   item.VBT01_DESPROG,
            indclibloc: item.VBT01_INDCLIBLOC,
            desprogblocco: item.VBT01_DESPROGBLOCCO,
            label:     item.VBT01_DESPROGBLOCCO,
            gruppo:     item.VBT01_GRUPPO,
            ref:        item.VBT01_REF,
            statoprog:  item.VBT01_STATOPROG,
            molt:  item.VBT01_MOLT
    }))
  };
    return  mappedData;
};


export type Nodi = {
        idnodo? :string;
        codprog? :string;
        codnodo? :string;
        ditta? :number;
        desnodo? :string;
        label? :string;
        tiponodo:string;
  };

export type  NodiApiResponse = {
  results: Array<Nodi>;
  count: number;
};
export function mapJsonToNodiApiResponse(jsonData: any): NodiApiResponse {
  const mappedData: NodiApiResponse = {
            count: jsonData.count,
            results: jsonData.results.map((item: any) => ({
            idnodo:           item.VBT04_ID,
            codprog:  item.VBT04_CODPROG_VBT01,
            codnodo:  item.VBT04_CODNODO,
            ditta:  item.VBT04_DITTA,
            desnodo:   item.VBT04_DESNODO,
            label:   item.VBT04_DESNODO,
            tiponodo:   item.VBT04_TIPONODO,

    }))
  };

  return mappedData;
};

export type Attivita = {
        idatt? :string;
        codprog? :string;
        codatt? :string;
        ditta? :number;
        desatt? :string;
        label? :string;
  };

export type  AttivitaApiResponse = {
  results: Array<Attivita>;
  count: number;
};

export function mapJsonToAttivitaApiResponse(jsonData: any): AttivitaApiResponse {
  const mappedData: AttivitaApiResponse = {
            count: jsonData.count,
            results: jsonData.results.map((item: any) => ({
            idatt:           item.VBT05_ID,
            codprog:  item.VBT05_CODPROG_VBT01,
            codatt:  item.VBT05_CODATT,
            ditta:  item.VBT05_DITTA,
            desatt:   item.VBT05_DESATT,
            label:   item.VBT05_DESATT,

    }))
  };

  return mappedData;
};



export type VersOreDTO = {
  nrrel?: number;
  desditta?: string;
  datareg?: Date | null;
  variante?: string;
  opzione?: string;
  coddip?: string;
  oreord?: number;
  minord?: number;
  codprog?: string;
  note?: string;
  codatt?: string;
  codnodo?: string;
  datains?: Date | null;
  desnodo?: string;
  desatt?: string;
  codagente?: string;
  nomeagente?: string;
  ref?: string;
  flgval?: string;
  desprog?: string;
  ore?: number;
  oremin?: string;
  luogo?: string;
  qtalav?: number,
  inizlav?: Date | null,
  finelav?: Date | null,
  qtalavoremin?: string,
  orestraord?: number;
  minstraord?: number;
  oremineff?: string;
};


export type VersOreDTOApiResponse = {
  results: Array<VersOreDTO>;
  count: number;
};


export function mapJsonToVersOreDTOApiResponse(jsonData: any): VersOreDTOApiResponse {
  const mappedData: VersOreDTOApiResponse = {
    count: jsonData.count,
    results: jsonData.results.map((item: any) => ({
      nrrel: item.VBT00_NRREL,
      desditta: item.VBT00_DESDITTA,
      datareg: item.VBT00_DATAREG ? new Date(item.VBT00_DATAREG) : null,
      variante: item.VBT00_VARIANTE?.trim() || null,
      opzione:  item.VBT00_OPZIONE.trim(),
      coddip: item.VBT00_CODDIP,
      oreord: item.VBT00_OREORD,
      minord: item.VBT00_MINORD,
      codprog: item.VBT00_CODPROG,
      note: item.VBT00_NOTE,
      codatt: item.VBT00_CODATT,
      codnodo: item.VBT00_CODNODO,
      datains: item.VBT00_DATAINS ? new Date(item.VBT00_DATAINS) : null,
      desnodo: item.VBT00_DESNODO,
      desatt: item.VBT00_DESATT,
      codagente: item.VBT00_CODAGENTE,
      nomeagente: item.VBT00_NOMEAGENTE,
      ref: item.VBT00_REF,
      flgval: item.VBT00_FLGVAL,
      desprog: item.VBT00_DESPROG,
      ore: item.VBT00_ORE,
      oremin: item.VBT00_OREMIN,
      luogo: item.VBT00_NUMRAP,
      qtalav: item.VBT00_QTALAV,
      inizlav: item.VBT00_INIZLAV,
      finelav: item.VBT00_FINELAV,
      qtalavoremin: item.VBT00_QTALAVOREMIN,
      orestraord: item.VBT00_ORESTRAORD,
      minstraord: item.VBT00_MINSTRAORD,
      oremineff: item.VBT00_OREMINEFF,
    })),
  };

  return mappedData;
}

export function mapVersOreDTOToJson(versOreDTO: VersOreDTO): any {
  return {
    VBT00_NRREL: versOreDTO.nrrel,
    VBT00_DESDITTA: versOreDTO.desditta,
    VBT00_DATAREG: versOreDTO.datareg,
    VBT00_VARIANTE: versOreDTO.variante,
    VBT00_OPZIONE: versOreDTO.opzione,
    VBT00_CODDIP: versOreDTO.coddip,
    VBT00_OREORD: versOreDTO.oreord,
    VBT00_MINORD: versOreDTO.minord,
    VBT00_CODPROG: versOreDTO.codprog,
    VBT00_NOTE: versOreDTO.note,
    VBT00_CODATT: versOreDTO.codatt,
    VBT00_CODNODO: versOreDTO.codnodo,
    VBT00_DATAINS: versOreDTO.datains,
    VBT00_DESNODO: versOreDTO.desnodo,
    VBT00_DESATT: versOreDTO.desatt,
    VBT00_CODAGENTE: versOreDTO.codagente,
    VBT00_NOMEAGENTE: versOreDTO.nomeagente,
    VBT00_REF: versOreDTO.ref,
    VBT00_FLGVAL: versOreDTO.flgval,
    VBT00_DESPROG: versOreDTO.desprog,
    VBT00_ORE: versOreDTO.ore,
    VBT00_OREMIN: versOreDTO.oremin,
    VBT00_NUMRAP: versOreDTO.luogo,
    VBT00_QTALAV: versOreDTO.qtalav,
    VBT00_INIZLAV: versOreDTO.inizlav,
    VBT00_FINELAV: versOreDTO.finelav,
    VBT00_QTALAVOREMIN: versOreDTO.qtalavoremin,
    VBT00_ORESTRAORD: versOreDTO.orestraord,
    VBT00_MINSTRAORD: versOreDTO.minstraord,
    VBT00_OREMINEFF: versOreDTO.oremineff,
  };
}







